import React, {useState} from "react";
import styles from "./Filters.module.scss";
import classNames from "classnames";
import _ from "lodash";
import Select from "./../Select/Select";
import ActionMenuButtonsRow from "./ActionMenuButtonsRow";
import ActionMenuCheckbox from "./ActionMenuCheckbox";

const NoOptions = () => {
    return <div className={styles["no-options"]}>No options</div>
}

export const DropdownFilter = ({filterOptions, filterState, close, updateFilter, className, filterConfig}) => {
    const [internalState, setInternalState] = useState(filterState.valuesArray || []);

    return  <div className={classNames(styles['filter'], className)} style={{minWidth: 285}}>
        <div className={styles['dropdown-filter-content']}>
            {!filterOptions || filterOptions.length === 0 && <NoOptions/>}
            {filterOptions && filterOptions.length > 0 &&
            <div>
                <label className={styles['drop-down-label']}>{filterConfig.label}</label>
                <Select onChange={setInternalState}
                        options={filterOptions}
                        value={internalState}
                        isSearchable={ true }
                        isMulti={ true }
                        placeholder={filterConfig.placeholder}
                />
            </div>}
        </div>
        <ActionMenuButtonsRow>
            <button type="button" onClick={(e) => {
                updateFilter(_.pickBy(_.keyBy(internalState, "value")));
                close(e);
            }}>Apply</button>
            <button type="button" onClick={() => {
                setInternalState([]);
            }}>Clear</button>
        </ActionMenuButtonsRow>
    </div>
};


export const CheckboxFilter = ({filterOptions, filterState, close, updateFilter, className}) => {
    const [internalState, setInternalState] = useState(filterState.values || {});
    return  <div className={classNames(styles['filter'], className)}>
        <div className={styles['checkbox-filter-content']}>
            {!filterOptions || filterOptions.length === 0 && <NoOptions/>}
            {filterOptions && filterOptions.length > 0 && filterOptions.map(({value, label, disabled}, index) => {
                return <ActionMenuCheckbox className={index === 0 ? styles["first-child"] : ""} key={value} disabled={disabled} name={value} checked={internalState[value] || false} ariaLabel={label} dataTestId={`checkbox-filter-${label}`} onChange={() => setInternalState({...internalState, [value]: !internalState[value]})}>
                    <span>{label}</span>
                </ActionMenuCheckbox>
            })}
        </div>
        <ActionMenuButtonsRow>
            <button type="button" onClick={(e) => {
                updateFilter(internalState);
                close(e);
            }}>Apply</button>
            <button type="button" onClick={() => {
                setInternalState({});
            }}>Clear</button>
        </ActionMenuButtonsRow>
    </div>
};
